import type { ContentPolicyList_YiQueryQuery as RawData } from './ContentPolicyListYIQuery.generated'
import { YOGA_INTERNATIONAL_CONTENT_POLICY_NAME } from '../constants'

export function extractContentPolicyId (rawData?: RawData) {
  const rawPolicyId = rawData?.contentPolicyList?.contentPolicies?.find(
    (policy) => policy?.name === YOGA_INTERNATIONAL_CONTENT_POLICY_NAME,
  )?.policyId

  return rawPolicyId ? Number(rawPolicyId) : null
}
